import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles({
  title: {
    marginBottom: 8,
  },
  description: {
    opacity: "0.7",
    marginBottom: 0,
  },
  footer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 16,
    paddingTop: 32,
    '@media (max-width: 460px)': {
      flexDirection: "column"
    }
  },
  button: {
    width: "100%",
  },
});
